import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=59555f4d&"
import script from "./imprint.vue?vue&type=script&lang=ts&"
export * from "./imprint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports